module.exports = __webpack_public_path__ + "img/zhuanli4.1b48ae7c.png";